import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

const form = document.querySelector(".form");

form.addEventListener('submit', (event) => {
    event.preventDefault();
     
    const delay = Number(form.elements.delay.value);
    const state = form.elements.state.value;


    function createPromise(value, delay, isPositive) {
        const promise = new Promise((res, rej) => {
            setTimeout(() => {
                if (isPositive) {
                    res(value);
                } else {
                    rej(value);
                }
            }, delay)
        });
        return promise
    }

    const promise = createPromise(delay, delay, state === "fulfilled");

    promise
        .then((delay) => {
            iziToast.success({
                title: "Success",
                message: `✅ Fulfilled promise in ${delay}ms`,
                position: "topRight",
            });
        })
        .catch((delay) => {
            iziToast.error({
                title: "Error",
                message: `❌ Rejected promise in ${delay}ms`,
                position: "topRight",
            });
        });

});
